// Revisado: 2025-12-18 [I18n Scan]
/**
 * Calculates the score for a single stat (Speed, Stamina, Power, Guts, Wit).
 * Based on LogicToCalculateStats.js
 * 
 * Logic:
 * - Stat is divided into chunks of 50.
 * - Each chunk has a specific multiplier from the list.
 * - Logic applies for stats <= 1200 (Global version limit).
 * 
 * @param {number} statValue - The value of the stat (e.g. 1000)
 * @returns {number} The calculated score
 */
export const calculateStatScore = (statValue) => {
    // Multipliers for each 50-point block (up to 1200+)
    // List f from LogicToCalculateStats.js
    const multipliers = [.5, .8, 1, 1.3, 1.6, 1.8, 2.1, 2.4, 2.6, 2.8, 2.9, 3, 3.1, 3.3, 3.4, 3.5, 3.9, 4.1, 4.2, 4.3, 5.2, 5.5, 6.6, 6.8, 6.9];

    // Logic for stats <= 1200
    if (statValue <= 1200) {
        // The reference logic adds 1 to the stat value
        // "si por ejemplo tengo 1001 eso significa que tengo 20 bloques de 50 puntos y un blque de 1 punto"
        // With t += 1, 1000 becomes 1001 (20 blocks + 1 point).
        let t = statValue + 1;
        let score = 0;

        for (let i = 0; i < multipliers.length; i++) {
            if (t > 50) {
                score += 50 * multipliers[i];
                t -= 50;
            } else {
                score += t * multipliers[i];
                break;
            }
        }
        return Math.floor(score);
    }

    // Logic for stats > 1200 (Expanded cap)
    // List m from LogicToCalculateStats.js
    const extendedMultipliers = [7.888, 8, 8.1, 8.3, 8.4, 8.5, 8.6, 8.8, 8.9, 9, 9.2, 9.3, 9.4, 9.6, 9.7, 9.8, 10, 10.1, 10.2, 10.3, 10.5, 10.6, 10.7, 10.9, 11, 11.1, 11.3, 11.4, 11.5, 11.7, 11.8, 11.9, 12.1, 12.2, 12.3, 12.4, 12.6, 12.7, 12.8, 13, 13.1, 13.2, 13.4, 13.5, 13.6, 13.8, 13.9, 14, 14.1, 14.3, 14.4, 14.5, 14.7, 14.8, 14.9, 15.1, 15.2, 15.3, 15.5, 15.6, 15.7, 15.9, 16, 16.1, 16.2, 16.4, 16.5, 16.6, 16.8, 16.9, 17, 17.2, 17.3, 17.4, 17.6, 17.7, 17.8, 17.9, 18.1, 18.2, 18.3];

    if (statValue > 1200 && statValue <= 1209) {
        return Math.ceil((statValue - 1200) * extendedMultipliers[0]) + 3841;
    }

    if (statValue > 1209 && statValue <= 2000) {
        let t = statValue - 1210 + 1;
        let score = 0;
        for (let i = 1; i < extendedMultipliers.length; i++) {
            if (t > 10) {
                score += Math.ceil(10 * extendedMultipliers[i]);
                t -= 10;
                continue;
            }
            score += Math.ceil(t * extendedMultipliers[i]);
            break;
        }
        return score + 3912;
    }

    return 0;
};
// Revisado: 2025-12-16
